import { render } from "./ProductFilter.vue?vue&type=template&id=449fb0fc"
import script from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-categorization-drag-drop/components/filter/ProductFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "449fb0fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('449fb0fc', __exports__)) {
    api.reload('449fb0fc', __exports__)
  }
  
  module.hot.accept("./ProductFilter.vue?vue&type=template&id=449fb0fc", () => {
    api.rerender('449fb0fc', render)
  })

}


export default __exports__